export type RedeemFailureKind =
  | 'slot-gone' | 'no-grant' | 'expired' | 'outside-window'
  | 'daily-cap' | 'wiring' | 'relogin' | 'generic';

export interface RedeemFailureUx {
  message: string;
  kind: RedeemFailureKind;
  offerPaidBooking: boolean;
  refetchAvailability: boolean;
}

// Maps the server's {status,error} to UX. The server's message text is the source
// of truth for the 422 sub-cases (see spec §6); we surface `error` directly and
// classify by status + a substring of the known messages.
export function mapRedeemFailure(status: number, error: string): RedeemFailureUx {
  const base = (kind: RedeemFailureKind, opts: Partial<RedeemFailureUx> = {}): RedeemFailureUx => ({
    message: error, kind, offerPaidBooking: false, refetchAvailability: false, ...opts,
  });

  if (status === 409) return base('slot-gone', { message: 'That slot was just taken — pick another.', refetchAvailability: true });

  if (status === 422) {
    if (/expired/i.test(error)) return base('expired');
    if (/no active/i.test(error)) return base('no-grant');
    if (/48 hours/i.test(error)) return base('outside-window');
    if (/daily limit/i.test(error)) return base('daily-cap', { offerPaidBooking: true });
    return base('generic');
  }

  if (status === 400) {
    if (/driver id/i.test(error)) return base('relogin');
    return base('wiring');
  }

  return base('generic', { message: 'Something went wrong. Please try again.' });
}
